<template>
  <div>
    <template v-if="loading">
      <div class="d-flex justify-center my-5">
        <app-material-icon 
          name="progress_activity"
          color="primary"
          class="spinning"
          style="font-size: 100px;"
        />
      </div>
    </template>
    <template v-else>
      <DocumentSharePickerGroup v-for="group in groups"
                                :key="`group-${group.id}`"
                                :forcePmSelection="forcePmSelection"
                                :forceCurrentUserSelection="forceCurrentUserSelection"
                                :group="group"
                                :multi-select="multiSelect"
                                :users-only="usersOnly"
                                data-locator="group-selection"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { DocumentSharePickerActionTypes } from '@/store/modules/document-share-picker/action_types'

import DocumentSharePickerGroup from './DocumentSharePickerGroup.vue'

export default {
  name: 'DocumentSharePicker',
  components: { DocumentSharePickerGroup },
  props: {
    forcePmSelection: {
      type: Boolean,
      required: true,
    },
    forceCurrentUserSelection: {
      type: Boolean,
      default: false,
    },
    usersOnly: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: true,
    },
    /**
     * Resets members and groups in the parent component
     * In the case of a modal with steppers, for example,
     * where you don't want to reset the data when you switch from one stepper to another
     */
    resetGroupsAndMembersInParent: {
      type: Boolean,
      default: false,
    },
    /**
     * If provided, load groups visible by this specific user
     * instead of all groups in the room
     */
    forUserId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState('groups', ['groups', 'loading']),
  },
  watch: {
    forUserId: {
      handler (newUserId) {
        const mnemo = this.$route.params.mnemo
        if (newUserId) {
          this.GET_GROUPS_FOR_USER({ mnemo, userId: newUserId })
        } else {
          this.GET_GROUPS(mnemo)
        }
      },
      immediate: true,
    },
  },
  beforeUnmount () {
    if (!this.resetGroupsAndMembersInParent) {
      this.RESET_SELECTED_GROUPS_AND_MEMBERS()
    }

    this.RESET_DISABLED_GROUPS_AND_MEMBERS()
  },
  methods: {
    ...mapActions('documentSharePicker', [
      DocumentSharePickerActionTypes.RESET_DISABLED_MEMBERS,
      DocumentSharePickerActionTypes.RESET_DISABLED_GROUPS_AND_MEMBERS,
      DocumentSharePickerActionTypes.RESET_SELECTED_GROUPS_AND_MEMBERS,
    ]),
    ...mapActions('groups', ['GET_GROUPS', 'GET_GROUPS_FOR_USER']),
  },
}
</script>
